import React, { useState } from "react";
import { Modal, Tab } from "react-bootstrap";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import {
  AESEncryption,
  formatDate,
  noDataFound,
  splitDateSlash,
} from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import { useEffect } from "react";
import { useDeactivate } from "./useAPMaster";
import { Constants } from "../../CommonMethhods/Constants";

function ApMasterTab(props) {
  const [onCangesStatus, setOnCangesStatus] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [compliChangeStatus, setCompliChangeStatus] = useState("");
  const [compliTextArea, setCompliTextArea] = useState("");
  const [financeChangeStatus, setFinanceChangeStatus] = useState("");
  const [financeTextArea, setFinanceTextArea] = useState("");
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [selectedAPCode, setSelectedAPCode] = useState(null);
  // const projectRole = JSON.parse(localStorage.getItem("project"));
  // const getRole = projectRole[0]?.Role?.Name;
  const getRole = localStorage.getItem("cosmosProjectRole");

  const {isLoading, deactivateAP} = useDeactivate();

  const {
    apMasterDetail,
    handleScrollApMaster,
    forUpdateMaster,
    scrollLoader,
    apNotFound,
    UpdateRemarkAPI,
    // roleMaster,
    mainApMasterLoader,
    setApMasterDetail
  } = props;


  function UpdateItem(data) {
    forUpdateMaster(data);
  }
  function handleSubmitRemark(apCode, commercialStatus) {
    if (
      commercialStatus !== "" &&
      (onCangesStatus === commercialStatus || !onCangesStatus)
    ) {
      toast.error("Status is already submitted.");
      return;
    }

    if (onCangesStatus) {
      if (
        onCangesStatus === "REJECTED" &&
        onCangesStatus !== commercialStatus
      ) {
        if (textAreaValue.length > 0) {
          UpdateRemarkAPI(apCode, onCangesStatus, textAreaValue, "Commercial").then(() => {
            setOnCangesStatus("");
            setTextAreaValue("");
          });
        } else {
          toast.error("Please enter remarks for rejection");
        }
      } else if (
        (onCangesStatus === "APPROVED" || onCangesStatus === "PENDING") &&
        onCangesStatus !== commercialStatus &&
        onCangesStatus?.length > 0
      ) {
        UpdateRemarkAPI(apCode, onCangesStatus, textAreaValue, "Commercial").then(() => {
          setOnCangesStatus("");
          setTextAreaValue("");
        });
      }
    } else {
      toast.error("Please select Commercial Status and enter Remark");
    }
  }

  function handleCompliSubmitRemark(apCode, complianceStatus) {
    if (
      complianceStatus !== "" &&
      (compliChangeStatus === complianceStatus || !compliChangeStatus)
    ) {
      toast.error("Status is already submitted.");
      return;
    }

    if (compliChangeStatus) {
      if (
        compliChangeStatus === "REJECTED" &&
        compliChangeStatus !== complianceStatus
      ) {
        if (compliTextArea?.length > 0) {
          UpdateRemarkAPI(apCode, compliChangeStatus, compliTextArea, "Compliance").then(() => {
            setCompliChangeStatus("");
            setCompliTextArea("");
          });
        } else {
          toast.error("Please enter remarks for rejection");
        }
      } else if (
        (compliChangeStatus === "APPROVED" || compliChangeStatus === "PENDING") &&
        compliChangeStatus !== complianceStatus &&
        compliChangeStatus?.length > 0
      ) {
        UpdateRemarkAPI(apCode, compliChangeStatus, compliTextArea, "Compliance").then(() => {
          setCompliChangeStatus("");
          setCompliTextArea("");
        });
      }
    } else {
      toast.error("Please select Compliance Status and enter Remark");
    }
  }

  function handleFinanceSubmitRemark(apCode, financeStatus) {
    if (
      financeStatus !== "" &&
      (financeChangeStatus === financeStatus || !financeChangeStatus)
    ) {
      toast.error("Status is already submitted.");
      return;
    }

    if (financeChangeStatus) {
      if (
        financeChangeStatus === "REJECTED" &&
        financeChangeStatus !== financeStatus
      ) {
        if (financeTextArea?.length > 0) {
          UpdateRemarkAPI(apCode, financeChangeStatus, financeTextArea, "Finance").then(() => {
            setFinanceChangeStatus("");
            setFinanceTextArea("");
          });
        } else {
          toast.error("Please enter remarks for rejection");
        }
      } else if (
        (financeChangeStatus === "APPROVED" || financeChangeStatus === "PENDING") &&
        financeChangeStatus !== financeTextArea &&
        financeChangeStatus?.length > 0
      ) {
        UpdateRemarkAPI(apCode, financeChangeStatus, financeTextArea, "Finance").then(() => {
          setFinanceChangeStatus("");
            setFinanceTextArea("");
        });
      }
    } else {
      toast.error("Please select Finance Status and enter Remark");
    }
  }

  function handleTextArea(e) {
    setTextAreaValue(e.target.value);
  }

  function handleCompliTextArea(e) {
    setCompliTextArea(e.target.value);
  }
  function handleFinanceTextArea(e) {
    setFinanceTextArea(e.target.value);
  }

  const handleDeactivateClick = (apCode) => {
    setIsDeactivateModalOpen(true);
    setSelectedAPCode(apCode);
  }

  const handleModalHide = () => {
    setIsDeactivateModalOpen(false);
    setSelectedAPCode(null);
  }

  const handleConfirmClick = async () => {
    const payload = {
      apCode: selectedAPCode,
      isActive: false,
    };
    const encryptedPayload = AESEncryption(payload);

    const {success, data} = await deactivateAP(encryptedPayload);
    if (success && data) {
      toast.success(data.data);
      handleModalHide();
      setApMasterDetail(prevState => {
        return prevState.map(ap => {
          if (ap.apCode === selectedAPCode) {
            return {
              ...ap,
              isActive: false
            }
          }
          return ap;
        })
      });
    } else {
      toast.error(data?.message || Constants.GENERIC_ERROR_MESSAGE);
    }
  };

  const apDataMap = (apMasterDetail) => {
    return (
      apMasterDetail &&
      apMasterDetail.map((item, key) => {
        let {
          apName,
          apCode,
          brokerage,
          segment,
          apType,
          masterAP,
          pan,
          accountNo,
          ifscCode,
          bankName,
          isAPRegistered,
          exchange,
          gstNo,
          commUploadLink,
          commUploadFileName,
          gstDocLink,
          gstDocFileName,
          canChequeLink,
          canChequeFileName,
          // fileData,
          bseRegNo,
          nseRegNo,
          commercialStatus,
          commercialRemarks,
          complianceStatus,
          complianceRemarks,
          financeStatus,
          financeRemarks,
          // fileName,
          isGSTRegistered,
          apSharing01,
          apSharing02,
          apSharing03,
          apSharing04,
          apSharing05,
          brokerageSlab01,
          brokerageSlab02,
          brokerageSlab03,
          brokerageSlab04,
          brokerageSlab05,
          isActive
        } = item;
        const isAllowed =
          getRole === "FranchiseManager" &&
            (commercialStatus === "APPROVED" ||
              commercialStatus === "REJECTED");
        return (
          <tr key={key}>
            <td>{apName || "-"}</td>
            <td>{apCode || "-"}</td>
            <td>{brokerage?.modules?.sharing || 0}%</td>
            <td>{brokerage?.modules?.del || 0}%</td>
            <td>{brokerage?.modules?.future || 0}%</td>
            <td>₹{brokerage?.modules?.nifty || 0}</td>
            <td>₹{brokerage?.modules?.bankNifty || 0}</td>
            <td>₹{brokerage?.modules?.optionStock || 0}</td>
            <td>{brokerage?.modules?.mName || "-"}</td>
            <td className="">{brokerage?.modules?.mRemarks || "-"}</td>
            {/* <td>{brokerage?.modules?.mtflasROI || 0}%</td> */}
            {/* <td>{brokerage?.modules?.mtflasShare || 0}%</td> */}
            {/* <td>{brokerage?.modules?.from || 0}</td> */}
            {/* <td>{brokerage?.modules?.to || 0}</td> */}
            {/* <td>{brokerage?.modules?.indAmc || 0}</td> */}
            {/* <td>{brokerage?.modules?.indSharing || 0}%</td> */}
            {/* <td>{brokerage?.modules?.indEarnPe || 0}</td> */}
            {/* <td>{brokerage?.modules?.cornpAMC || 0}</td> */}
            {/* <td>{brokerage?.modules?.cornpSharing || 0}%</td>
            <td>{brokerage?.modules?.cornpEarnP || 0}</td> */}
            <td>
              {(segment.length > 0 &&
                segment.map((value) => {
                  return `${value.segName},`;
                })) ||
                "-"}
            </td>
            <td>{apType?.apName || "-"}</td>
            <td>{masterAP || "-"}</td>
            <td>{pan || "-"}</td>
            <td>{accountNo || "-"}</td>
            <td>{ifscCode || "-"}</td>
            <td>{bankName || "-"}</td>
            <td>
              {canChequeLink ? (
                <div className="d-flex align-items-center">
                  <div
                    onClick={() => {
                      window.open(
                        canChequeLink,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    className="tagAnchor"
                  >
                    {canChequeFileName}
                  </div>
                  <span
                    id="eyeicon"
                    className="icon-Pass_see eyeIcon-master"
                    onClick={() => {
                      window.open(
                        canChequeLink,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  />
                </div>
              ) : (
                "-"
              )}
            </td>
            <td>{isAPRegistered || "-"}</td>
            <td>{bseRegNo || "-"}</td>
            <td>{nseRegNo || "-"}</td>
            <td>
              {(exchange.length > 0 &&
                exchange.map((value) => {
                  return `${value.name},`;
                })) ||
                "-"}
            </td>
            <td>{isGSTRegistered || "-"}</td>
            <td>{gstNo || "-"}</td>
            <td>
              {gstDocLink ? (
                <div className="d-flex align-items-center">
                  <div
                    onClick={() => {
                      window.open(gstDocLink, "_blank", "noopener,noreferrer");
                    }}
                    className="tagAnchor"
                  >
                    {gstDocFileName}
                  </div>
                  <span
                    id="eyeicon"
                    className="icon-Pass_see eyeIcon-master"
                    onClick={() => {
                      window.open(gstDocLink, "_blank", "noopener,noreferrer");
                    }}
                  />
                </div>
              ) : (
                "-"
              )}
            </td>
            <td>{brokerageSlab01||"-"}</td>
            <td>{apSharing01||"-"}</td>
            <td>{brokerageSlab02|| "-"}</td>
            <td>{apSharing02||"-"}</td>
            <td>{brokerageSlab03||"-"}</td>
            <td>{apSharing03||"-"}</td>
            <td>{brokerageSlab04||"-"}</td>
            <td>{apSharing04||"-"}</td>
            <td>{brokerageSlab05||"-"}</td>
            <td>{apSharing05||"-"}</td>
            <td>{splitDateSlash(formatDate(brokerage?.modules?.modifiedDate)) || "-"}</td>
            <td>
              {commUploadLink ? (
                <div className="d-flex align-items-center">
                  <div
                    onClick={() => {
                      window.open(
                        commUploadLink,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                    className="tagAnchor"
                  >
                    {commUploadFileName}
                  </div>
                  <span
                    id="eyeicon"
                    className="icon-Pass_see eyeIcon-master"
                    onClick={() => {
                      window.open(
                        commUploadLink,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  />
                </div>
              ) : (
                "-"
              )}
            </td>
{console.log(getRole, commercialStatus, "commercialStatus")}
            <td>
              <select
                className={`report-custom-select ${
                  commercialStatus.toUpperCase() === "APPROVED"
                    ? "approve-btn"
                    : commercialStatus.toUpperCase() === "PENDING"
                    ? "hold-btn"
                    : commercialStatus.toUpperCase() === "REJECTED"
                    ? "rejected-btn"
                    : ""
                }`}
                onChange={(e) => setOnCangesStatus(e.target.value)}
                disabled={
                  getRole === "FranchiseHead" &&
                  commercialStatus === "PENDING" ? false : true
                }
                defaultValue={commercialStatus.toUpperCase()}
              >
                <option value="" disabled selected hidden>
                  Select
                </option>
                <option value="REJECTED">Rejected</option>
                <option value="PENDING">Hold</option>
                <option value="APPROVED">Approved</option>
              </select>
              {/* )} */}
            </td>
            <td className="width300 ">
              <div className="d-flex align-items-center">
                <div className="remark-text">
                  <textarea
                    type="text"
                    defaultValue={commercialRemarks}
                    placeholder="Please type remark here and submit..."
                    onChange={(e) => handleTextArea(e)}
                    readOnly={
                      getRole === "FranchiseHead" &&
                      commercialStatus === "PENDING" ? false : true
                      // || commercialStatus === "APPROVED"
                      //   ? true
                      //   : false
                      
                    }
                  />
                </div>

                {getRole === "FranchiseHead" &&
                commercialStatus === "PENDING" ?
                <button
                  type="button"
                  className="btn-remark-submit"
                  onClick={() => handleSubmitRemark(apCode, commercialStatus)}
                  // disabled={roleMaster === "FranchiseHead" ? false : true}
                >
                  SUBMIT
                </button>
                : ""}
                
              </div>
            </td>

            <td>
              <select
                className={`report-custom-select ${
                  complianceStatus.toUpperCase() === "APPROVED"
                    ? "approve-btn"
                    : complianceStatus.toUpperCase() === "PENDING"
                    ? "hold-btn"
                    : complianceStatus.toUpperCase() === "REJECTED"
                    ? "rejected-btn"
                    : ""
                }`}
                onChange={(e) => setCompliChangeStatus(e.target.value)}
                disabled={ 
                  commercialStatus.toUpperCase() === "APPROVED" &&
                  getRole === "Compliance" &&
                  complianceStatus === "PENDING" ? false : true
                }
                defaultValue={complianceStatus.toUpperCase()}
              >
                <option value="" disabled selected hidden>
                  Select
                </option>
                <option value="REJECTED">Rejected</option>
                <option value="PENDING">Hold</option>
                <option value="APPROVED">Approved</option>
              </select>
              {/* )} */}
            </td>
            <td className="width300 ">
              <div className="d-flex align-items-center">
                <div className="remark-text">
                  <textarea
                    type="text"
                    defaultValue={complianceRemarks}
                    placeholder="Please type remark here and submit..."
                    onChange={(e) => handleCompliTextArea(e)}
                    readOnly={
                      // commercialStatus.toUpperCase() === "APPROVED" &&
                      // getRole === "Compliance" ? false : true 
                      commercialStatus.toUpperCase() === "APPROVED" &&
                  getRole === "Compliance" &&
                  complianceStatus === "PENDING" ? false : true
                    }
                  />
                </div>

                {commercialStatus.toUpperCase() === "APPROVED" &&
                  getRole === "Compliance" &&
                  complianceStatus === "PENDING" ?
                <button
                  type="button"
                  className="btn-remark-submit"
                  onClick={() => handleCompliSubmitRemark(apCode, complianceRemarks)}
                  // disabled={roleMaster === "FranchiseHead" ? false : true}
                >
                  SUBMIT
                </button>
                : ""}
                
              </div>
            </td>

            <td>
              <select
                className={`report-custom-select ${
                  financeStatus.toUpperCase() === "APPROVED"
                    ? "approve-btn"
                    : financeStatus.toUpperCase() === "PENDING"
                    ? "hold-btn"
                    : financeStatus.toUpperCase() === "REJECTED"
                    ? "rejected-btn"
                    : ""
                }`}
                onChange={(e) => setFinanceChangeStatus(e.target.value)}
                disabled={
                  commercialStatus.toUpperCase() === "APPROVED" && 
                complianceStatus.toUpperCase() === "APPROVED" &&
                getRole === "Finance" &&
                financeStatus === "PENDING" ? false : true
                }
                defaultValue={financeStatus.toUpperCase()}
              >
                <option value="" disabled selected hidden>
                  Select
                </option>
                <option value="REJECTED">Rejected</option>
                <option value="PENDING">Hold</option>
                <option value="APPROVED">Approved</option>
              </select>
              {/* )} */}
            </td>
            <td className="width300 ">
              <div className="d-flex align-items-center">
                <div className="remark-text">
                  <textarea
                    type="text"
                    defaultValue={financeRemarks}
                    placeholder="Please type remark here and submit..."
                    onChange={(e) => handleFinanceTextArea(e)}
                    readOnly={
                    //   commercialStatus.toUpperCase() === "APPROVED" && 
                    // complianceStatus.toUpperCase() === "APPROVED" &&
                    // getRole === "Finance" ? false : true
                    commercialStatus.toUpperCase() === "APPROVED" && 
                complianceStatus.toUpperCase() === "APPROVED" &&
                getRole === "Finance" &&
                financeStatus === "PENDING" ? false : true
                    }
                  />
                </div>

                {
                  commercialStatus.toUpperCase() === "APPROVED" && 
                  complianceStatus.toUpperCase() === "APPROVED" &&
                  getRole === "Finance" &&
                  financeStatus === "PENDING" ?
                // commercialStatus.toUpperCase() === "APPROVED" && 
                // complianceStatus.toUpperCase() === "APPROVED" &&
                // getRole === "Finance" ?
                <button
                  type="button"
                  className="btn-remark-submit"
                  onClick={() => handleFinanceSubmitRemark(apCode, financeRemarks)}
                  // disabled={roleMaster === "FranchiseHead" ? false : true}
                >
                  SUBMIT
                </button>
                : ""}
                
              </div>
            </td>


            <td>
              <button
                type="button"
                className="icon-Edit edit-icon"
                onClick={() => UpdateItem(item)}
                disabled={!isAllowed || !isActive}
                style={{color: !isAllowed || !isActive ? "#ccc" : "" }}
              ></button>
            </td>
            
            <td>
              <button
                className="active-deactivate-btn"
                type="button" 
                disabled={!isActive}
                onClick={() => handleDeactivateClick(apCode)}
              >
                {isActive ? "Deactivate" : "Deactivated"}
              </button>
            </td>
          </tr>
        );
      })
    );
  };

  console.log(getRole, "getRole");

  return (
    <>
    <Tab.Pane eventKey="ApMaster">
      {mainApMasterLoader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        <div className="scroll-table master_table" id="for-scroll-left">
          <table className="table">
            <thead>
              <tr className="masterTableHead">
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" colSpan="5" className="">
                  Base Brokerage Detail
                </th>
                <th scope="col"></th>
                <th scope="col" className=""></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" className=""></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              <tr>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" colSpan="3">
                  Option
                </th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th></th>
              </tr>
              <tr>
                <th scope="col">AP Name</th>
                <th scope="col">AP Code</th>
                <th scope="col">AP Sharing</th>
                <th scope="col">Delivery</th>
                <th scope="col" className="">
                  Future/Cash Intraday
                </th>
                <th scope="col">Nifty Option (per lot)</th>
                <th scope="col">Bank Nifty Option (per lot)</th>
                <th scope="col">Option Stock (per lot)</th>

                <th scope="col">Module</th>
                <th scope="col" className="">
                  Module Remarks
                </th>
                {/* <th scope="col">MTF/LAS ROI</th>
                <th scope="col">MTF/LAS Sharing AP</th> */}
                {/* <th scope="col">From (In Lakhs)</th>
                <th scope="col">To (In Lakhs)</th>
                <th scope="col">Ind. AMC</th>
                <th scope="col">Ind. Sharing</th>
                <th scope="col">Ind. EPA</th>
                <th scope="col">Corp. AMC</th>
                <th scope="col">Corp. Sharing</th>
                <th scope="col">Corp. EPA</th> */}
                <th scope="col">Segment</th>
                <th scope="col">AP Type</th>
                <th scope="col">Master AP</th>
                <th scope="col">PAN</th>
                <th scope="col">Account Number</th>
                <th scope="col">Ifsc Code</th>
                <th scope="col">Bank Name</th>
                <th scope="col">Cancelled Cheque</th>
                <th scope="col">Is AP Registered</th>
                <th scope="col">BSE Registration Number</th>
                <th scope="col">NSE Registration Number</th>
                <th scope="col">Exchange</th>
                <th scope="col">Is GST Registered</th>
                <th scope="col">GST Number</th>
                <th scope="col">GST Document</th>
                <th scope="col">Brokerage Slab 01</th>
                <th scope="col">Ap Sharing 01</th>
                <th scope="col">Brokerage Slab 02</th>
                <th scope="col">Ap Sharing 02</th>
                <th scope="col">Brokerage Slab 03</th>
                <th scope="col">Ap Sharing 03</th>
                <th scope="col">Brokerage Slab 04</th>
                <th scope="col">Ap Sharing 04</th>
                <th scope="col">Brokerage Slab 05</th>
                <th scope="col">Ap Sharing 05</th>
                <th scope="col">Modify Date</th>
                <th scope="col">View Commercial</th>
                <th scope="col">Commercial Status</th>
                <th scope="col" className="width300">
                  Remark
                </th>
                <th scope="col">Compliance Status</th>
                <th scope="col" className="width300">
                Compliance Team Remark
                </th>
                <th scope="col">Finance Status</th>
                <th scope="col" className="width300">
                Finance Team Remark
                </th>
                <th scope="col">Modify/Edit</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            {apMasterDetail && apMasterDetail.length > 0 ? (
              <tbody onScroll={handleScrollApMaster} id="apMasterpageId">
                {apDataMap(apMasterDetail)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            ) : (
              <tbody style={{ height: "100px" }} id="apMasterpageId">
                {apNotFound && noDataFound(apNotFound)}
              </tbody>
            )}
          </table>
        </div>
      )}
    </Tab.Pane>

    <Modal className="deactivation-modal" show={isDeactivateModalOpen} centered onHide={handleModalHide}>
      <Modal.Header>
        <button
              type="button"
              className="btn-close filter-closeBtn"
              aria-label="Close"
              onClick={handleModalHide}
        >
          <span className="icon-close"></span>
        </button>
      </Modal.Header>

      <Modal.Body>
        <p className="deactivation-modal__warning">Are you sure you want to Deactivate the AP?</p> 
      </Modal.Body>

      <Modal.Footer>
        <div className="deactivation-modal__button-wrapper">
          <button onClick={handleConfirmClick} disabled={isLoading}>{isLoading ? "Loading..." : "Confirm"}</button>

          <button onClick={handleModalHide}>Cancel</button>
        </div>
      </Modal.Footer>
    </Modal>
    </>
  );
}

export default ApMasterTab;
